module.exports = __webpack_public_path__ + "img/logo01.ccacb0f7.svg";